import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onBeforeUnmount, onMounted, reactive, ref, watchEffect } from 'vue'
export type DisplayBreakpoint = keyof DisplayThresholds

export interface DisplayThresholds {
  xs: number
  sm: number
  md: number
  lg: number
  xl: number
  '2xl': number
}

export interface DisplayValue {
  xs: unknown
  sm: unknown
  md: unknown
  lg: unknown
  xl: unknown
  '2xl': unknown
}

export interface DisplayInstance {
  xs: boolean
  sm: boolean
  md: boolean
  lg: boolean
  xl: boolean
  xxl: boolean
  smAndUp: boolean
  mdAndUp: boolean
  lgAndUp: boolean
  xlAndUp: boolean
  smAndDown: boolean
  mdAndDown: boolean
  lgAndDown: boolean
  xlAndDown: boolean
  name: DisplayBreakpoint
  height: number
  width: number
  thresholds: DisplayThresholds
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BlockContainer',
  setup(__props) {

const container = ref<HTMLElement>()

const containerWidth = ref()

const resize = () => {
  let element = container.value
  containerWidth.value = element.clientWidth
}

let resizeObserver:ResizeObserver|null = null

onMounted(() => {
  resize()
  resizeObserver = new ResizeObserver(resize)
  resizeObserver.observe(container.value)
})

onBeforeUnmount(() => {
  if (resizeObserver) {
    resizeObserver.unobserve(container.value)
  }
})

//this can be injected as a plugin if customisation is required
const thresholds = {
  xs: 0,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
}

const state = reactive({} as DisplayInstance)

watchEffect(() => {
  const xs = containerWidth.value < thresholds.sm
  const sm = containerWidth.value < thresholds.md && !xs
  const md = containerWidth.value < thresholds.lg && !(sm || xs)
  const lg = containerWidth.value < thresholds.xl && !(md || sm || xs)
  const xl = containerWidth.value < thresholds['2xl'] && !(lg || md || sm || xs)
  const xxl = containerWidth.value >= thresholds['2xl']
  const name =
  xs ? 'xs'
    : sm ? 'sm'
      : md ? 'md'
        : lg ? 'lg'
          : xl ? 'xl'
            : '2xl'

  state.xs = xs
  state.sm = sm
  state.md = md
  state.lg = lg
  state.xl = xl
  state.xxl = xxl
  state.smAndUp = !xs
  state.mdAndUp = !(xs || sm)
  state.lgAndUp = !(xs || sm || md)
  state.xlAndUp = !(xs || sm || md || lg)
  state.smAndDown = !(md || lg || xl || '2xl')
  state.mdAndDown = !(lg || xl || '2xl')
  state.lgAndDown = !(xl || '2xl')
  state.xlAndDown = !'2xl'
  state.name = name
  state.width = containerWidth.value
  state.thresholds = thresholds
})

const getDisplayValue = (valueOptions:Partial<DisplayValue>) => {
  if (state.xlAndUp && valueOptions.xl !== undefined) { 
    return valueOptions.xl
  }
  if (state.lgAndUp && valueOptions.lg !== undefined) { 
    return valueOptions.lg
  }
  if (state.mdAndUp && valueOptions.md !== undefined) { 
    return valueOptions.md
  }
  if (state.smAndUp && valueOptions.sm !== undefined) { 
    return valueOptions.sm
  }
  return valueOptions.xs
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "container",
    ref: container,
    class: "clinical-blocks"
  }, [
    _renderSlot(_ctx.$slots, "default", {
      width: containerWidth.value,
      display: state,
      getDisplayValue: getDisplayValue
    })
  ], 512))
}
}

})